import { TFunction } from 'next-i18next';

import React from 'react';

import { ActionMenu, Button } from '@thinkific/chalk';
import { DotsThreeVertical, Trash } from '@thinkific/chalk/react-icons';

import { DANGER_TYPE } from 'components/new/utils/constants';

type PostAction = {
  name: string;
  title?: string;
  type?: 'danger';
  text: string;
  onClick(e: Event): void;
};

interface PostActionsProps {
  actionsList?: PostAction[];
  t: TFunction;
}

const PostActions = ({ actionsList = [], t }: PostActionsProps) => {
  return (
    <>
      <ActionMenu
        dataQa="inline-actions__btn"
        items={actionsList.map((action) => ({
          label: typeof action.text === 'string' ? action.text : (action.title as string) || '',
          onClick: (e: React.MouseEvent<HTMLButtonElement>) => {
            e?.stopPropagation();
            action.onClick(e as unknown as Event);
          },
          ...(action.type === DANGER_TYPE && { icon: Trash, variant: 'destructive' }),
        }))}
      >
        <Button
          aria-label={t('Open/close actions menu')}
          emphasis="low"
          icon={DotsThreeVertical}
          size="sm"
          hiddenLabel
        >
          Actions
        </Button>
      </ActionMenu>
    </>
  );
};

export default PostActions;
